import { useEffect } from 'react';

export const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="privacy-policy-page">
      <h1 className="font-heading text-4xl mb-8">Privacy Policy</h1>
      <p className="text-gray-500 text-sm mb-8">Last Updated: March 14, 2026</p>
      
      <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
        <section>
          <h2 className="font-heading text-2xl mb-4">1. Introduction</h2>
          <p>
            Jax Remodeling Solutions LLC ("Company," "we," "us," or "our") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">2. Information We Collect</h2>
          <h3 className="font-semibold text-lg mt-4 mb-2">Personal Information</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Name, email address, phone number, and mailing address</li>
            <li>Project details and property information</li>
            <li>Payment and billing information</li>
            <li>Communications you send to us</li>
            <li>Employee information (for portal users)</li>
          </ul>
          
          <h3 className="font-semibold text-lg mt-4 mb-2">Automatically Collected Information</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>IP address and device information</li>
            <li>Browser type and version</li>
            <li>Pages visited and time spent on site</li>
            <li>Referring website addresses</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">3. How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide and manage our remodeling services</li>
            <li>To process payments and send invoices</li>
            <li>To communicate about your project</li>
            <li>To send marketing communications (with your consent)</li>
            <li>To improve our website and services</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">4. Information Sharing</h2>
          <p>We may share your information with:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Service providers who assist in our operations</li>
            <li>Subcontractors working on your project</li>
            <li>Legal authorities when required by law</li>
            <li>Business partners with your consent</li>
          </ul>
          <p className="mt-4">We do not sell your personal information to third parties.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to processing of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">7. Cookies</h2>
          <p>
            We use cookies and similar tracking technologies to improve your browsing experience. You can control cookies through your browser settings. See our Cookie Policy for more details.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">8. Children's Privacy</h2>
          <p>
            Our services are not directed to individuals under 18. We do not knowingly collect personal information from children.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">9. Contact Us</h2>
          <p>For privacy-related inquiries:</p>
          <ul className="list-none space-y-2 mt-4">
            <li><strong>Email:</strong> jaxremodelingsolutions@gmail.com</li>
            <li><strong>Phone:</strong> (904) 863-6673</li>
            <li><strong>Address:</strong> St. Augustine, FL</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
